
import { Component, Prop, Vue } from 'vue-property-decorator'
import UploadImg from './svg/upload.vue'

@Component({
  components: {
    UploadImg
  }
})
export default class Nav extends Vue {
  navOnClick (to:string) {
    this.$router.push(to)
  }
}
